import React, { useEffect, useState } from 'react'
import { fetchData, PostData } from '../Services/httpHandelars'
import { useGlobalContext } from '../context'
import Snackbar from '../Components/Snackbar';
import Loader from '../Components/Loader';

export default function OrgnisationSetup() {

    const [form, setForm] = useState({Name:"", Location:"", Address:"",LOGO:"",contactPerson:"", personNumber:"", email:""})
    const [disableButton, setdisableButton] = useState(true);
    const [snacBar, setSnacBar ] =useState({snacStatus: false, message:"", snackType:""})


    const {setLoading, loading} = useGlobalContext();

      useEffect(
        () => {
          if(snacBar.snacStatus == true){
            console.log(snacBar.snacStatus)
            setTimeout(() => setSnacBar(false), 2000);
          }
        },
        
        [snacBar.snacStatus]
      );


    const HandleSubmit =()=>{
  
      if(disableButton){
        setdisableButton(disableButton => !disableButton)
      }else{
      setLoading(true)
      if(form.Name && form.Location && form.Address && form.email && form.personNumber){

        const update = {
            Name: form.Name,
            Location: form.Location,
            Address: form.Address,
            EmailID: form.email,
            ContactNumber: form.personNumber
        }
  
          PostData ("/api/orgnaization/edit", update )
          .then((data)=>{
            setLoading(false)
           
            if(data.status == true){
              setSnacBar({...snacBar, 
                snacStatus: data.status,
                message:data.message,
                snackType:"Success"
              })
              setdisableButton(true)
            }else{
              setLoading(false)
              setSnacBar({...snacBar, 
                snacStatus: data.status,
                message:"Responce Failed",
                snackType:"Error"
              })
            }
  
  
            fetchData("/api/orgnization/get").then((data) => {
              setLoading(false)
              const dataValue = JSON.parse(data);
              setForm({...form,
                Name:dataValue[0]?.Name,
                Location:dataValue[0]?.Location,
                Address:dataValue[0]?.Address,
                email:dataValue[0]?.EmailID,
                personNumber:dataValue[0]?.ContactNumber,
               
              
              })
            }).catch(e => console.log(e));  
  
  
          }).catch((err)=>{
            setLoading(false)

            setSnacBar({...snacBar, 
              snacStatus: true,
              message:"Responce Failed",
              snackType:"Error"
            })
          })}else{
            
            setLoading(false)
            setSnacBar({...snacBar, 
              snacStatus: true,
              message:"Please fill all the fields",
              snackType:"warning"
            })

          }
      }
    }


    useEffect(()=>{
      fetchData("/api/orgnization/get").then((data) => {
        const dataValue = JSON.parse(data);

        setForm({...form,
          Name:dataValue[0]?.Name,
          Location:dataValue[0]?.Location,
          Address:dataValue[0]?.Address,
          email:dataValue[0]?.EmailID,
          personNumber:dataValue[0]?.ContactNumber,
        
        })
      }).catch(e => console.log(e));
    },[])


    const HandleChange = (e) =>{
        setForm({...form, [e.target.name]: e.target.value })
    }

    const fileChanged = (e) => {
      const f = e.target.files[0];
      setForm({...form, [e.target.name]: f })
    }

  return (
    <React.Fragment>
    {!loading ? 
      <div>
      <div className = "flex flex-col justify-center items-center">
        <div className='w-3/5'>
        <div className="mt-24 flex justify-center ">
          <h1 className="text-4xl text-center font-medium leading-6 text-gray-900 ">{disableButton ?  "Organization Setup" :  "Edit Organization Setup"}</h1>
        </div>
           
                <div className="mt-10 px-4 py-10 bg-white sm:p-6">
                  <div className="grid grid-cols-6 gap-6">
                    <div className="col-span-6 sm:col-span-3">
                      <label htmlFor="first-name" className="block text-sm font-medium text-gray-700">
                        Name
                      </label>
                      <input
                        disabled = {disableButton}
                        type="text"
                        name="Name"
                        onChange={HandleChange}
                        value={form.Name }
                        id="Name"
                        autoComplete="given-name"
                        className="block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      />
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                      <label htmlFor="first-name" className="block text-sm font-medium text-gray-700">
                      Location
                      </label>
                      <input
                        disabled = {disableButton}
                        type="text"
                        name="Location"
                        id="Location"
                        onChange={HandleChange}
                        value={form.Location}
                        autoComplete="given-name"
                        className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      />
                    </div>

                    <div className="col-span-6 sm:col-span-6">
                      <label htmlFor="first-name" className="block text-sm font-medium text-gray-700">
                        Address
                      </label>
                      <input
                        disabled = {disableButton}
                        type="text"
                        name="Address"
                        id="Address"
                        onChange={HandleChange}
                        value={form.Address}
                        autoComplete="given-name"
                        className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      />
                    </div>
                   
                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                    <label htmlFor="Contact Person" className="block text-sm font-medium text-gray-700">
                        Contact Person
                      </label>
                      <input
                        disabled = {disableButton}
                        type="text"
                        name="contactPerson"
                        onChange={HandleChange}
                        id="contactPerson"
                        value={form.contactPerson}

                        autoComplete="given-name"
                        className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      />
                    </div>

                    <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                    <label htmlFor="first-name" className="block text-sm font-medium text-gray-700">
                        Contact Number 
                      </label>
                      <input
                        disabled = {disableButton}
                        type="text"
                        name="personNumber"
                        onChange={HandleChange}
                        id="personNumber"
                        value={form.personNumber}
                        autoComplete="given-name"
                        className=" block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      />
                    </div>

                    <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                        E-mail
                      </label>
                      <input
                      disabled = {disableButton}
                        type="text"
                        name="email"
                        id="email"
                        onChange={HandleChange}
                        value={form.email}
                        autoComplete="given-name"
                        className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      />
                    </div>
                    <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                        Organization Logo
                      </label>
                      <input
                      disabled = {disableButton}
                        type="file"
                        name="logo"
                        id="logo"
                        onChange={fileChanged}
                        value={form.LOGO}
                        autoComplete="given-name"
                        className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      />
                    </div>
                  </div>
                </div>
                <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                  <button
                    onClick={HandleSubmit}
                    className="inline-flex justify-center  py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                  >
                     {disableButton ? "Edit" : "Update" }
                  </button>
                </div>


            </div>
          </div>
            { snacBar?.snacStatus &&
              
              <Snackbar snackType={snacBar?.snackType} message={snacBar.message} status={snacBar?.snacStatus} setSnacBar={setSnacBar}/>
            }    
          </div>
                
            : <Loader />}
    </React.Fragment>
  )
}
